import "./App.css";
import "./Carousel.css";

import "bootstrap/dist/css/bootstrap.css";

import FloatingWhatsApp from "./components/commons/whatsappbtn.js";
import { Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import PerfilEmpleado from "./components/pages/gestionEmpleados/PerfilEmpleado";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

//home//
import Home from "./components/pages/homepage.js";
import TrabajaConNosotros from "./components/pages/trabajaconnosotros/trabajaConNosotros.js";
import CirculoLogo from "./components/pages/trabajaconnosotros/tarjetaTrabajaconNos.js";

//Acerca//
import Sedes from "./components/pages/acerca/sedes.js";
import Mision from "./components/pages/acerca/mision.js";
import Horarios from "./components/pages/acerca/horariossedes/horarios.js";

//proyecto educativo//
import ProyectoEducativo from "./components/pages/proyectoeducativo/proyectoEducativo.js";
import NivelInicial from "./components/pages/proyectoeducativo/nivelinicial/homeinicial.js";
import NivelPrimario from "./components/pages/proyectoeducativo/nivelprimario/homeprimario.js";
import NivelSecundario from "./components/pages/proyectoeducativo/nivelsecundario/homesecundario.js";
import OrientacionAccordion from "./components/pages/proyectoeducativo/nivelsecundario/orientacionAccordion.js";
import CarruselJardin from "./components/pages/proyectoeducativo/nivelinicial/carruselJardin.js";
import CarruselPrimario from "./components/pages/proyectoeducativo/nivelprimario/carruselPrimaria.js";
import CarruselSecundario from "./components/pages/proyectoeducativo/nivelsecundario/carruselSecundario.js";
import CardSecundario from "./components/pages/proyectoeducativo/nivelsecundario/cardSecundario.js";
import HorariosSedes from "./components/pages/acerca/horariossedes/horariosSedes.js";
//actividades//
import ArteActividad from "./components/pages/actividades/arteActividad.js";
import Deportes from "./components/pages/actividades/deportes/deportes.js";
import Actividades from "./components/pages/actividades/actividades/acividades.js";

import TextoActividades from "./components/pages/actividades/textoActividadesPrimaria.js";
import MenuInteremedio from "./components/pages/actividades/actividades/menuInteremedioActividades.js";
import MenuInteremedioAcerca from "./components/pages/acerca/menuInteremedioAcerca.js";
import MenuInteremedioNiveles from "./components/pages/proyectoeducativo/menuInteremedioNiveles.js";
import AventurasQueEducan from "./components/pages/aventurasQueEducan.js";
//nuestras casa//
import Equipos from "./components/pages/nuestrascasas/equipos.js";
import Uniformes from "./components/pages/nuestrascasas/Uniforms.js";

import Configuracion from "./components/pages/autogestion/configuracion.js";
import CambiarPassword from "./components/pages/autogestion/CambiarPassword";
import Inicio from "./components/pages/autogestion/Inicio";
import Acerca from "./components/pages/acerca/acerca.js";
import Staff from "./components/pages/institucional/Staff";
import ExAlumnos from "./components/pages/acerca/exalumnos/ExAlumnos.js";
import AutoGestion from "./components/pages/autogestion/Login";
import AutoGestionEmpleados from "./components/pages/autogestion/LoginEmpleado.js";
import DashboardEmpleados from "./components/pages/gestionEmpleados/DashboardEmpleado.js";
import MisRecibos from "./components/pages/gestionEmpleados/MisRecibos.js";
import Footer from "./layouts/footer.js";
import Facturas from "./components/pages/autogestion/facturas.js";
import FiestasDeLasArtes from "./components/pages/fiestasdelasartes.js";
import PreInscripciones from "./components/pages/preinscripciones.js";
import MiComunion from "./components/pages/fiestasdelasartes.js";
import Salidas from "./components/pages/fiestasdelasartes.js";
import Contacto from "./components/pages/acerca/contacto/contacto.js";
import Catequesis from "./components/pages/catequesis.js";
import Admision from "./components/pages/admision/admision.js";
import PropuestasExtraCurriculares from "./components/pages/propuestasExtracurriculares/propuestasExtraCurriculares.js";
import InglesIntensivo from "./components/pages/proyectoeducativo/InglesIntensivo.js";
import ImageCarousel from "./components/pages/imageCarousel.js";
import ReproduccionVideoIni from "./components/reproduccionVideoIni.js";
import { useLocation } from "react-router-dom";
import Planillacambio from "./components/pages/gestionadministrativa/tramites/planillacambio.js";
import AdhesionalDebito from "./components/pages/gestionadministrativa/tramites/adhesionaldebito.js";
import "@fontsource/nunito/200.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import ScrollToTop from "./components/commons/ScrollToTop";
import AppLayout from "./AppLayout";
import Historia from "./components/pages/acerca/historia/historia.js";
import AppHome from "./components/apphome.js";
import TextoCatequesis from "./components/pages/textoCatequesis.js";
import PanelLayout from "./layouts/PanelLayout";

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const location = useLocation();
  const isFacturasPage = location.pathname === "/facturas";
  const ocultarBotones = location.pathname !== "/";

  return (
    <Provider store={store}>
      <>
        <ScrollToTop />

        {!location.pathname.toLowerCase().includes("/misrecibos") &&
          !location.pathname.toLowerCase().includes("/dashboardempleados") &&
          !location.pathname.toLowerCase().includes("/cambiar-password") &&
          !location.pathname.toLowerCase().includes("/perfilempleado") && (
            <AppLayout />
          )}
        <div
          className={`LocalBody ${isFacturasPage ? "facturas-background" : ""}`}
        >
          <Routes>
            <Route path="dashboardEmpleados" element={<DashboardEmpleados />} />
            <Route path="misRecibos" element={<MisRecibos />} />
            <Route path="perfilEmpleado" element={<PerfilEmpleado />} />
            <Route
              path="cambiar-password"
              element={
                <PanelLayout>
                  <CambiarPassword />
                </PanelLayout>
              }
            />
            <Route path="textoCatequesis" element={<TextoCatequesis />} />
            <Route path="acerca" element={<Acerca />} />
            <Route path="configuracion" element={<Configuracion />} />
            <Route path="exalumnos" element={<ExAlumnos />} />
            <Route path="login" element={<AutoGestion />} />
            <Route path="loginEmpleados" element={<AutoGestionEmpleados />} />
            <Route path="inicio" element={<Inicio />} />
            <Route path="facturas" element={<Facturas />} />
            <Route path="home" element={<Home />} />
            <Route path="contacto" element={<Contacto />} />
            <Route path="nivelinicial" element={<NivelInicial />} />
            <Route path="nivelprimario" element={<NivelPrimario />} />
            <Route path="nivelsecundario" element={<NivelSecundario />} />
            <Route path="trabajaConNosotros" element={<TrabajaConNosotros />} />
            <Route path="catequesis" element={<Catequesis />} />
            <Route path="horarios" element={<Horarios />} />
            <Route path="cardSecundario" element={<CardSecundario />} />
            <Route path="actividades" element={<Actividades />} />
            <Route
              path="menuInteremedioAcerca"
              element={<MenuInteremedioAcerca />}
            />
            <Route path="menuInteremedio" element={<MenuInteremedio />} />
            <Route
              path="menuInteremedioNiveles"
              element={<MenuInteremedioNiveles />}
            />
            <Route path="horariosSedes" element={<HorariosSedes />} />
            <Route path="proyectoEducativo" element={<ProyectoEducativo />} />
            <Route path="circuloLogo" element={<CirculoLogo />} />
            <Route path="Staff" element={<Staff />} />
            <Route path="admision" element={<Admision />} />
            <Route
              path="propuestasExtraCurriculares"
              element={<PropuestasExtraCurriculares />}
            />
            <Route path="InglesIntensivo" element={<InglesIntensivo />} />
            <Route path="fiestasdelasartes" element={<FiestasDeLasArtes />} />
            <Route path="micomunion" element={<MiComunion />} />
            <Route path="salidas" element={<Salidas />} />
            <Route path="deportes" element={<Deportes />} />
            <Route path="preinscripciones" element={<PreInscripciones />} />
            <Route path="planillacambio" element={<Planillacambio />} />
            <Route path="adhesionaldebito" element={<AdhesionalDebito />} />
            <Route path="imageCarousel" element={<ImageCarousel />} />
            <Route
              path="reproduccionVideoIni"
              element={<ReproduccionVideoIni />}
            />
            <Route path="/Uniforms" element={<Uniformes />} />
            <Route path="/homeinicial" element={<NivelInicial />} />
            <Route path="/equipos" element={<Equipos />} />
            <Route path="/sedes" element={<Sedes />} />
            <Route path="/mision" element={<Mision />} />
            <Route path="/arteActividad" element={<ArteActividad />} />
            <Route
              path="/orientacionAccordion"
              element={<OrientacionAccordion />}
            />
            <Route path="/carruselJardin" element={<CarruselJardin />} />
            <Route path="/carruselPrimario" element={<CarruselPrimario />} />
            <Route
              path="/carruselSecundario"
              element={<CarruselSecundario />}
            />
            <Route path="/textoActividades" element={<TextoActividades />} />
            <Route
              path="/aventurasQueEducan"
              element={<AventurasQueEducan />}
            />
            <Route path="/historia" element={<Historia />} />
          </Routes>
          {!ocultarBotones && <AppHome></AppHome>}
        </div>
        <FloatingWhatsApp />
        <Footer />
      </>
    </Provider>
  );
}

export default App;
